<script lang="ts">
  /* The layers list. `Layers.svelte` carried an `inSheet` prop so it could be
     two shapes; the panel chrome supplies the surface now, so it is always just
     the list. */
  import Layers from '../Layers.svelte';
</script>

<Layers />
